(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7056,7163],{

/***/ 87163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Loader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42041);



function Loader(param) {
    let { size  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            textAlign: "center",
            padding: "10px 0"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            size: size
        })
    });
}


/***/ }),

/***/ 41854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Price; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./hooks/useRedux.tsx
var useRedux = __webpack_require__(46496);
// EXTERNAL MODULE: ./redux/slices/currency.ts
var slices_currency = __webpack_require__(23102);
;// CONCATENATED MODULE: ./utils/numberToPrice.ts
const numberToPrice = function(number) {
    let digits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    if (number) {
        return number.toFixed(digits).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    }
    return "0";
};

;// CONCATENATED MODULE: ./components/price/price.tsx





function Price(param) {
    let { number =0 , minus , symbol , plus , digits , old  } = param;
    const currency = (0,useRedux/* useAppSelector */.C)(slices_currency/* selectCurrency */.j);
    const position = (currency === null || currency === void 0 ? void 0 : currency.position) || "before";
    const currencySymbol = symbol || (currency === null || currency === void 0 ? void 0 : currency.symbol) || "$";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "".concat(minus ? "red" : "", " ").concat(old ? "strike" : ""),
        children: [
            minus ? "-" : "",
            plus ? "+" : "",
            position === "before" ? currencySymbol : "",
            numberToPrice(number, digits),
            position === "after" ? currencySymbol : ""
        ]
    });
}


/***/ }),

/***/ 86637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ SearchResult; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+style_k46btafrtimgapyjpq7bbdyomu/node_modules/@mui/material/Skeleton/Skeleton.js + 3 modules
var Skeleton = __webpack_require__(52709);
// EXTERNAL MODULE: ./components/searchResult/searchResult.module.scss
var searchResult_module = __webpack_require__(18733);
var searchResult_module_default = /*#__PURE__*/__webpack_require__.n(searchResult_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-i18next@12.3.1_i18next@22.5.1_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(53218);
// EXTERNAL MODULE: ./components/searchResultItem/searchResultItem.module.scss
var searchResultItem_module = __webpack_require__(48695);
var searchResultItem_module_default = /*#__PURE__*/__webpack_require__.n(searchResultItem_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/link.js
var next_link = __webpack_require__(6339);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/shopLogoBackground/shopLogoBackground.module.scss
var shopLogoBackground_module = __webpack_require__(35018);
var shopLogoBackground_module_default = /*#__PURE__*/__webpack_require__.n(shopLogoBackground_module);
// EXTERNAL MODULE: ./utils/getImage.ts
var getImage = __webpack_require__(7592);
// EXTERNAL MODULE: ./components/fallbackImage/fallbackImage.tsx
var fallbackImage = __webpack_require__(25627);
;// CONCATENATED MODULE: ./components/shopLogoBackground/shopLogoBackground.tsx






function ShopLogoBackground(param) {
    let { data , size ="medium" , loading =false  } = param;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((shopLogoBackground_module_default()).logo, " ").concat((shopLogoBackground_module_default())[size]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (shopLogoBackground_module_default()).logoWrapper,
            children: !loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(fallbackImage/* default */.Z, {
                fill: true,
                src: (0,getImage/* default */.Z)(data === null || data === void 0 ? void 0 : data.logo_img),
                alt: data === null || data === void 0 ? void 0 : (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title,
                sizes: "(max-width: 768px) 40px, 60px",
                quality: 90
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                variant: "rectangular",
                className: (shopLogoBackground_module_default()).shimmer
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/searchResultItem/shopResultItem.tsx





function ShopResultItem(param) {
    let { data , onClickItem  } = param;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (searchResultItem_module_default()).row,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
            href: "/shop/".concat(data.id),
            className: (searchResultItem_module_default()).flex,
            onClick: onClickItem,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopLogoBackground, {
                    data: data
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (searchResultItem_module_default()).naming,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            className: (searchResultItem_module_default()).shopTitle,
                            children: (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (searchResultItem_module_default()).desc,
                            children: (ref1 = data.translation) === null || ref1 === void 0 ? void 0 : ref1.description
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./components/price/price.tsx + 1 modules
var price = __webpack_require__(41854);
;// CONCATENATED MODULE: ./components/searchResultItem/productResultItem.tsx







function ProductResultItem(param) {
    let { data , onClickItem  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (searchResultItem_module_default()).row,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
            href: "/product/".concat(data === null || data === void 0 ? void 0 : data.uuid),
            shallow: true,
            className: (searchResultItem_module_default()).flex,
            onClick: onClickItem,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (searchResultItem_module_default()).imgWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fallbackImage/* default */.Z, {
                        fill: true,
                        src: (0,getImage/* default */.Z)(data.img),
                        alt: (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title,
                        sizes: "320px",
                        quality: 90
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (searchResultItem_module_default()).naming,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            className: (searchResultItem_module_default()).shopTitle,
                            children: (ref1 = data.translation) === null || ref1 === void 0 ? void 0 : ref1.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (searchResultItem_module_default()).desc,
                            children: (ref2 = data.translation) === null || ref2 === void 0 ? void 0 : ref2.description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (searchResultItem_module_default()).price,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(price/* default */.Z, {
                                number: ((ref3 = data.stocks) === null || ref3 === void 0 ? void 0 : ref3.length) ? (ref4 = data.stocks[0]) === null || ref4 === void 0 ? void 0 : ref4.price : ((ref5 = data.stock) === null || ref5 === void 0 ? void 0 : ref5.price) || 0
                            })
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./components/loader/loader.tsx
var loader = __webpack_require__(87163);
;// CONCATENATED MODULE: ./components/searchResult/searchResult.tsx








function SearchResult(param) {
    let { shops , products , isLoading , isVisibleShops , handleClickItem , productTotal , shopTotal , isFetchingShopsNextPage , isFetchingProductsNextPage , hasProductsNextPage , hasShopsNextPage , fetchShopsNextPage , fetchProductsNextPage  } = param;
    const { t  } = (0,es/* useTranslation */.$G)();
    const shopLoader = (0,react.useRef)(null);
    const productLoader = (0,react.useRef)(null);
    const handleObserverShops = (0,react.useCallback)((entries)=>{
        const target = entries[0];
        if (target.isIntersecting && hasShopsNextPage) {
            fetchShopsNextPage();
        }
    }, [
        hasShopsNextPage,
        fetchShopsNextPage
    ]);
    (0,react.useEffect)(()=>{
        const option = {
            root: null,
            rootMargin: "20px",
            threshold: 0
        };
        const observer = new IntersectionObserver(handleObserverShops, option);
        if (shopLoader.current) observer.observe(shopLoader.current);
    }, [
        handleObserverShops,
        hasShopsNextPage,
        fetchShopsNextPage
    ]);
    const handleObserverProducts = (0,react.useCallback)((entries)=>{
        const target = entries[0];
        if (target.isIntersecting && hasProductsNextPage) {
            fetchProductsNextPage();
        }
    }, [
        hasProductsNextPage,
        fetchProductsNextPage
    ]);
    (0,react.useEffect)(()=>{
        const option = {
            root: null,
            rootMargin: "20px",
            threshold: 0
        };
        const observer = new IntersectionObserver(handleObserverProducts, option);
        if (productLoader.current) observer.observe(productLoader.current);
    }, [
        handleObserverProducts,
        hasProductsNextPage,
        fetchProductsNextPage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: !isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (searchResult_module_default()).wrapper,
            children: [
                isVisibleShops && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((searchResult_module_default()).block, " ").concat((searchResult_module_default()).line),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (searchResult_module_default()).header,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: (searchResult_module_default()).title,
                                    children: t("restaurant")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (searchResult_module_default()).text,
                                    children: t("found.number.results", {
                                        count: shopTotal
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (searchResult_module_default()).body,
                            children: shops.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ShopResultItem, {
                                    data: item,
                                    onClickItem: handleClickItem
                                }, item.id))
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: shopLoader
                }),
                isFetchingShopsNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(loader["default"], {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (searchResult_module_default()).block,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (searchResult_module_default()).header,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: (searchResult_module_default()).title,
                                    children: t("products")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (searchResult_module_default()).text,
                                    children: t("found.number.results", {
                                        count: productTotal
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (searchResult_module_default()).body,
                            children: products.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ProductResultItem, {
                                    data: item,
                                    onClickItem: handleClickItem
                                }, item.id))
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: productLoader
                }),
                isFetchingProductsNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(loader["default"], {})
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (searchResult_module_default()).wrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (searchResult_module_default()).container,
                children: Array.from(new Array(2)).map((item, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        variant: "rectangular",
                        className: (searchResult_module_default()).shimmer
                    }, "result" + idx))
            })
        })
    });
}


/***/ }),

/***/ 49571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ SearchSuggestion; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _searchSuggestion_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30778);
/* harmony import */ var _searchSuggestion_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_searchSuggestion_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53218);
/* harmony import */ var remixicon_react_TimeLineIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63100);
/* harmony import */ var remixicon_react_TimeLineIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_TimeLineIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var remixicon_react_CloseLineIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4704);
/* harmony import */ var remixicon_react_CloseLineIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_CloseLineIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var hooks_useRedux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46496);
/* harmony import */ var redux_slices_search__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92184);








function SearchSuggestion(param) {
    let { setSearchTerm  } = param;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    const history = (0,hooks_useRedux__WEBPACK_IMPORTED_MODULE_5__/* .useAppSelector */ .C)(redux_slices_search__WEBPACK_IMPORTED_MODULE_6__/* .selectSearchHistory */ .ag);
    const dispatch = (0,hooks_useRedux__WEBPACK_IMPORTED_MODULE_5__/* .useAppDispatch */ .T)();
    function handleClick(event, item) {
        event.preventDefault();
        setSearchTerm(item);
    }
    function handleClear() {
        dispatch((0,redux_slices_search__WEBPACK_IMPORTED_MODULE_6__/* .clearSearch */ .AQ)());
    }
    function handleRemove(item) {
        dispatch((0,redux_slices_search__WEBPACK_IMPORTED_MODULE_6__/* .removeFromSearch */ .iU)(item));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_searchSuggestion_module_scss__WEBPACK_IMPORTED_MODULE_7___default().wrapper),
        style: {
            display: history.length ? "block" : "none"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_searchSuggestion_module_scss__WEBPACK_IMPORTED_MODULE_7___default().header),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: (_searchSuggestion_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title),
                        children: t("recent.searches")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: (_searchSuggestion_module_scss__WEBPACK_IMPORTED_MODULE_7___default().clearBtn),
                        onClick: handleClear,
                        children: t("clear")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_searchSuggestion_module_scss__WEBPACK_IMPORTED_MODULE_7___default().body),
                children: history.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_searchSuggestion_module_scss__WEBPACK_IMPORTED_MODULE_7___default().flex),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                href: "suggestion",
                                className: (_searchSuggestion_module_scss__WEBPACK_IMPORTED_MODULE_7___default().textBtn),
                                onClick: (event)=>handleClick(event, item),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_TimeLineIcon__WEBPACK_IMPORTED_MODULE_3___default()), {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_searchSuggestion_module_scss__WEBPACK_IMPORTED_MODULE_7___default().text),
                                        children: item
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                className: (_searchSuggestion_module_scss__WEBPACK_IMPORTED_MODULE_7___default().closeBtn),
                                onClick: ()=>handleRemove(item),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_CloseLineIcon__WEBPACK_IMPORTED_MODULE_4___default()), {})
                            })
                        ]
                    }, "search" + item))
            })
        ]
    });
}


/***/ }),

/***/ 57056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ MobileSearchContainer; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./containers/mobileSearchContainer/mobileSearchContainer.module.scss
var mobileSearchContainer_module = __webpack_require__(17774);
var mobileSearchContainer_module_default = /*#__PURE__*/__webpack_require__.n(mobileSearchContainer_module);
// EXTERNAL MODULE: ./hooks/useDebounce.tsx
var useDebounce = __webpack_require__(57812);
// EXTERNAL MODULE: ./containers/modal/modal.tsx
var modal = __webpack_require__(49613);
// EXTERNAL MODULE: ./node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/ArrowLeftLineIcon.js
var ArrowLeftLineIcon = __webpack_require__(99817);
var ArrowLeftLineIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowLeftLineIcon);
// EXTERNAL MODULE: ./components/mobileSearch/mobileSearch.module.scss
var mobileSearch_module = __webpack_require__(43966);
var mobileSearch_module_default = /*#__PURE__*/__webpack_require__.n(mobileSearch_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/Search2LineIcon.js
var Search2LineIcon = __webpack_require__(24167);
var Search2LineIcon_default = /*#__PURE__*/__webpack_require__.n(Search2LineIcon);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-i18next@12.3.1_i18next@22.5.1_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(53218);
;// CONCATENATED MODULE: ./components/mobileSearch/mobileSearch.tsx





function MobileSearch(param) {
    let { searchTerm , setSearchTerm  } = param;
    const { t  } = (0,es/* useTranslation */.$G)();
    const inputRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        var ref;
        (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (mobileSearch_module_default()).search,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: "search",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Search2LineIcon_default()), {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "text",
                id: "search",
                ref: inputRef,
                placeholder: t("search"),
                autoComplete: "off",
                value: searchTerm,
                onChange: (event)=>setSearchTerm(event.target.value)
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.39.3_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(49532);
// EXTERNAL MODULE: ./services/shop.ts
var shop = __webpack_require__(67788);
// EXTERNAL MODULE: ./services/product.ts
var product = __webpack_require__(78564);
// EXTERNAL MODULE: ./components/searchResult/searchResult.tsx + 3 modules
var searchResult = __webpack_require__(86637);
// EXTERNAL MODULE: ./hooks/useUserLocation.tsx
var useUserLocation = __webpack_require__(52664);
// EXTERNAL MODULE: ./components/searchSuggestion/searchSuggestion.tsx
var searchSuggestion = __webpack_require__(49571);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@8.1.3_@types+react-dom@18.0.8_@types+react@18.3.28_react-dom@18.2.0_react@18.2.0__react@18.2.0_redux@4.2.1/node_modules/react-redux/es/index.js + 13 modules
var react_redux_es = __webpack_require__(28719);
// EXTERNAL MODULE: ./redux/slices/search.ts
var search = __webpack_require__(92184);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/router.js
var router = __webpack_require__(21867);
;// CONCATENATED MODULE: ./containers/mobileSearchContainer/mobileSearchContainer.tsx

















const shopRoutes = [
    "shop/"
];
function MobileSearchContainer(props) {
    var ref, ref1;
    const dispatch = (0,react_redux_es/* useDispatch */.I0)();
    const { i18n  } = (0,es/* useTranslation */.$G)();
    const { pathname , query  } = (0,router.useRouter)();
    const location = (0,useUserLocation/* default */.Z)();
    const locale = i18n.language;
    const [searchTerm, setSearchTerm] = (0,react.useState)("");
    const debouncedSearchTerm = (0,useDebounce/* default */.Z)(searchTerm.trim(), 400);
    const isRestaurantRoute = shopRoutes.some((item)=>pathname.includes(item));
    const resetSearch = ()=>setSearchTerm("");
    const { data: shops , fetchNextPage: fetchShopsNextPage , hasNextPage: hasShopsNextPage , isFetchingNextPage: isFetchingShopsNextPage , isLoading: isShopsLoading  } = (0,react_query_es.useInfiniteQuery)([
        "shopResult",
        debouncedSearchTerm,
        location,
        locale
    ], (param)=>{
        let { pageParam =1  } = param;
        return shop/* default.search */.Z.search({
            search: debouncedSearchTerm,
            page: pageParam,
            address: location,
            open: 1
        });
    }, {
        getNextPageParam: (lastPage)=>{
            if (lastPage.meta.current_page < lastPage.meta.last_page) {
                return lastPage.meta.current_page + 1;
            }
            return undefined;
        },
        retry: false,
        enabled: !!debouncedSearchTerm && !isRestaurantRoute
    });
    const { data: products , fetchNextPage: fetchProductsNextPage , hasNextPage: hasProductsNextPage , isFetchingNextPage: isFetchingProductsNextPage , isLoading: isProductsLoading  } = (0,react_query_es.useInfiniteQuery)([
        "productResult",
        debouncedSearchTerm,
        locale
    ], (param)=>{
        let { pageParam =1  } = param;
        return product/* default.search */.Z.search({
            search: debouncedSearchTerm,
            page: pageParam,
            shop_id: isRestaurantRoute ? query.id : undefined,
            address: location
        });
    }, {
        getNextPageParam: (lastPage)=>{
            if (lastPage.meta.current_page < lastPage.meta.last_page) {
                return lastPage.meta.current_page + 1;
            }
            return undefined;
        },
        retry: false,
        enabled: !!debouncedSearchTerm,
        onSuccess: ()=>{
            dispatch((0,search/* addToSearch */.fy)(debouncedSearchTerm));
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(modal["default"], {
        ...props,
        closable: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (mobileSearchContainer_module_default()).root,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSearch, {
                    searchTerm: searchTerm,
                    setSearchTerm: setSearchTerm
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (mobileSearchContainer_module_default()).wrapper,
                    children: [
                        !!debouncedSearchTerm && /*#__PURE__*/ (0,jsx_runtime.jsx)(searchResult["default"], {
                            isVisibleShops: !isRestaurantRoute,
                            shops: (shops === null || shops === void 0 ? void 0 : (ref = shops.pages) === null || ref === void 0 ? void 0 : ref.flatMap((item)=>item.data)) || [],
                            products: (products === null || products === void 0 ? void 0 : (ref1 = products.pages) === null || ref1 === void 0 ? void 0 : ref1.flatMap((item)=>item.data)) || [],
                            isLoading: isShopsLoading || isProductsLoading,
                            handleClickItem: ()=>{
                                resetSearch();
                                if (props.onClose) props.onClose({}, "backdropClick");
                            },
                            productTotal: (products === null || products === void 0 ? void 0 : products.pages) ? products.pages[0].meta.total : 0,
                            shopTotal: (shops === null || shops === void 0 ? void 0 : shops.pages) ? shops.pages[0].meta.total : 0,
                            isFetchingShopsNextPage: isFetchingShopsNextPage,
                            isFetchingProductsNextPage: isFetchingProductsNextPage,
                            hasProductsNextPage: !!hasProductsNextPage,
                            hasShopsNextPage: !!hasShopsNextPage,
                            fetchProductsNextPage: fetchProductsNextPage,
                            fetchShopsNextPage: fetchShopsNextPage
                        }),
                        !debouncedSearchTerm && /*#__PURE__*/ (0,jsx_runtime.jsx)(searchSuggestion["default"], {
                            setSearchTerm: setSearchTerm
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (mobileSearchContainer_module_default()).footer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (mobileSearchContainer_module_default()).circleBtn,
                        onClick: (event)=>{
                            if (props.onClose) props.onClose(event, "backdropClick");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowLeftLineIcon_default()), {})
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 49613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ModalContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var _modal_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5812);
/* harmony import */ var _modal_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_modal_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38264);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40939);
/* harmony import */ var remixicon_react_CloseFillIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18342);
/* harmony import */ var remixicon_react_CloseFillIcon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_CloseFillIcon__WEBPACK_IMPORTED_MODULE_1__);





const Wrapper = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(()=>({
        "& .MuiBackdrop-root": {
            backgroundColor: "rgba(0, 0, 0, 0.15)"
        },
        "& .MuiPaper-root": {
            backgroundColor: "var(--secondary-bg)",
            boxShadow: "var(--popover-box-shadow)",
            borderRadius: "25px",
            maxWidth: "100%"
        },
        "& .MuiPaper-root.MuiDialog-paperFullScreen": {
            borderRadius: 0
        }
    }));
function ModalContainer(param) {
    let { open , onClose , children , fullScreen , closable =true , position ="center" , PaperProps  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
        open: open,
        onClose: onClose,
        fullScreen: fullScreen,
        className: (_modal_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[position],
        PaperProps: PaperProps,
        children: [
            closable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: (_modal_module_scss__WEBPACK_IMPORTED_MODULE_4___default().closeBtn),
                onClick: ()=>{
                    if (onClose) onClose({}, "backdropClick");
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_CloseFillIcon__WEBPACK_IMPORTED_MODULE_1___default()), {})
            }),
            children
        ]
    });
}


/***/ }),

/***/ 57812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useDebounce; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);

function useDebounce(value, delay) {
    const [debounceValue, setDebounceValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setDebounceValue(value);
        }, delay);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        value,
        delay
    ]);
    return debounceValue;
}


/***/ }),

/***/ 43966:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"search":"mobileSearch_search__UC3Qx"};

/***/ }),

/***/ 18733:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"searchResult_wrapper__e31Dg","block":"searchResult_block__lSbJ1","line":"searchResult_line__evu3v","header":"searchResult_header__xe_se","title":"searchResult_title__WCRWn","text":"searchResult_text__D5Gl9","body":"searchResult_body__ozhC3","container":"searchResult_container__yDY5s","shimmer":"searchResult_shimmer__rIrJN"};

/***/ }),

/***/ 48695:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"row":"searchResultItem_row__3W2Do","flex":"searchResultItem_flex__GU1FF","naming":"searchResultItem_naming__kcii_","shopTitle":"searchResultItem_shopTitle___tQCy","desc":"searchResultItem_desc__2Fw5M","price":"searchResultItem_price__ICfd2","shopNaming":"searchResultItem_shopNaming__03EtZ","titleRateContainer":"searchResultItem_titleRateContainer__jw8MZ","rating":"searchResultItem_rating___0F1z","text":"searchResultItem_text__O6SXX","workTime":"searchResultItem_workTime__bl1k1","imgWrapper":"searchResultItem_imgWrapper__KLKVB"};

/***/ }),

/***/ 30778:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"searchSuggestion_wrapper__DhzAx","header":"searchSuggestion_header__2yJUq","title":"searchSuggestion_title__cQBBx","clearBtn":"searchSuggestion_clearBtn__ivlWk","body":"searchSuggestion_body__wRRwX","flex":"searchSuggestion_flex__Dkbu3","textBtn":"searchSuggestion_textBtn__bNQ_P","text":"searchSuggestion_text__EOAxX","closeBtn":"searchSuggestion_closeBtn__znyx7"};

/***/ }),

/***/ 35018:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo":"shopLogoBackground_logo___G4ih","logoWrapper":"shopLogoBackground_logoWrapper__nn0iU","shimmer":"shopLogoBackground_shimmer__0MFMI","large":"shopLogoBackground_large__wEZiZ","small":"shopLogoBackground_small__xIUwZ","medium":"shopLogoBackground_medium__pEnNf"};

/***/ }),

/***/ 17774:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"mobileSearchContainer_root__dwdkL","wrapper":"mobileSearchContainer_wrapper__cQnFf","header":"mobileSearchContainer_header__ole3N","title":"mobileSearchContainer_title__3audD","text":"mobileSearchContainer_text__UpHfs","body":"mobileSearchContainer_body__vu6IP","footer":"mobileSearchContainer_footer__K_feH","circleBtn":"mobileSearchContainer_circleBtn__JchEu"};

/***/ }),

/***/ 5812:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"closeBtn":"modal_closeBtn___o8U5","center":"modal_center__s8Z_X","right":"modal_right__9pSsY","left":"modal_left__DuU2N"};

/***/ })

}]);